/* MEKOROCHI Rakshabandhan landing - shared behaviours.
   Loaded once even if several sections request it. No storage APIs used. */
(function () {
  "use strict";
  if (window.MEK_RAKHI_READY) return;
  window.MEK_RAKHI_READY = true;

  /* ---------- countdown ---------- */
  function tickCountdown() {
    var nodes = document.querySelectorAll("[data-mek-countdown]");
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var target = Date.parse(el.getAttribute("data-mek-countdown"));
      if (isNaN(target)) { el.textContent = ""; continue; }
      var left = target - Date.now();
      if (left <= 0) {
        el.textContent = el.getAttribute("data-mek-closed") || "Orders closing - message us to check availability";
        continue;
      }
      var mins = Math.floor(left / 60000);
      var d = Math.floor(mins / 1440);
      var h = Math.floor((mins - d * 1440) / 60);
      var m = mins - d * 1440 - h * 60;
      var parts = [];
      if (d > 0) parts.push(d + "d");
      parts.push(h + "h");
      parts.push(m + "m");
      el.textContent = parts.join(" ") + " left";
    }
  }
  tickCountdown();
  setInterval(tickCountdown, 30000);

  /* ---------- FAQ accordion (delegated) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest ? e.target.closest(".mk-faq-q") : null;
    if (!btn) return;
    var panelId = btn.getAttribute("aria-controls");
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;
    var open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", open ? "false" : "true");
    if (open) { panel.classList.remove("is-open"); } else { panel.classList.add("is-open"); }
  });

  /* ---------- price labels follow the quantity ----------
     The formatted strings are precomputed in Liquid, one per quantity, so the
     shop's own currency format is always used. Index is quantity - 1. */
  function syncPriceLabels(qty) {
    var src = document.querySelector("[data-mek-prices]");
    if (!src) return;
    var list;
    try { list = JSON.parse(src.getAttribute("data-mek-prices")); } catch (err) { return; }
    if (!list || !list[qty - 1]) return;
    var labels = document.querySelectorAll("[data-mek-buy-price]");
    for (var i = 0; i < labels.length; i++) labels[i].textContent = list[qty - 1];
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var step = e.target.closest ? e.target.closest("[data-mek-step]") : null;
    if (!step) return;
    var wrap = step.closest("[data-mek-qty-wrap]");
    if (!wrap) return;
    var out = wrap.querySelector("[data-mek-qty-val]");
    var input = wrap.querySelector("[data-mek-qty-input]");
    var minus = wrap.querySelector('[data-mek-step="minus"]');
    var max = parseInt(wrap.getAttribute("data-mek-qty-max") || "10", 10);
    var val = parseInt((out && out.textContent) || "1", 10);
    if (isNaN(val)) val = 1;
    val = step.getAttribute("data-mek-step") === "plus" ? val + 1 : val - 1;
    if (val < 1) val = 1;
    if (val > max) val = max;
    if (out) out.textContent = String(val);
    if (input) input.value = String(val);
    if (minus) minus.disabled = val <= 1;
    var plus = wrap.querySelector('[data-mek-step="plus"]');
    if (plus) plus.disabled = val >= max;
    var mirrors = document.querySelectorAll("[data-mek-qty-mirror]");
    for (var i = 0; i < mirrors.length; i++) mirrors[i].value = String(val);
    syncPriceLabels(val);
  });

  /* ---------- sticky bar ---------- */
  var bar = document.querySelector("[data-mek-stickybar]");
  if (bar) {
    var sentinel = document.querySelector("[data-mek-sticky-after]") || document.querySelector(".mk-hero");
    if (sentinel && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { bar.classList.remove("is-visible"); }
          else { bar.classList.add("is-visible"); }
        }
      }, { rootMargin: "0px" }).observe(sentinel);
    } else {
      bar.classList.add("is-visible");
    }
  }

  /* ---------- scroll reveal ---------- */
  function bindReveal() {
    var items = document.querySelectorAll(".mek-anim .mk-r:not(.is-in)");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      for (var j = 0; j < items.length; j++) items[j].classList.add("is-in");
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add("is-in");
          obs.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: "0px 0px -8% 0px" });
    for (var k = 0; k < items.length; k++) io.observe(items[k]);
  }
  bindReveal();
  document.addEventListener("shopify:section:load", function () { bindReveal(); tickCountdown(); });
})();
